import * as React from "react";
function SvgArrowSort(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <g
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={4}
        stroke="currentColor"
      >
        <path d="M7 22l9 8 9-8M16 2v28" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgArrowSort);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
